import httpService from "./httpService";

export let StripePayment = (data: any) => {
  return httpService.post("stripe", data);
};

// Fetch Stripe customer payment methods, customer object and active subscriptions
export const getPaymentCards = (user_id: number) => {
  // Using get-subscriptions which also returns methods and customer,
  // so existing payment-method logic continues to work.
  return httpService.get(`connect/get-subscriptions?user_id=${user_id}`);
};

export const postNewPaymentCard = (data: any) => {
  return httpService.post("connect/store-payment-method", data);
};

export const deletePaymentCard = (data: any) => {
  return httpService.post("connect/remove-payment-method", data);
};

export const makeDefaultPaymentCard = (data: any) => {
  return httpService.post("connect/set-default-payment-method", data);
};

// Set a specific payment method for a particular subscription
export const setSubscriptionPaymentMethod = (data: any) => {
  return httpService.post("connect/set-payment-method-to-subscription", data);
};
